<div class="drawer-content-screen">
  @if (settingsIsLoading) {
    <div class="h-full">
      <app-skeleton-form-drawer></app-skeleton-form-drawer>
    </div>
  }

  @if (failedSettingsLoading) {
    <div class="flex-col-center">
      <app-something-went-wrong
        [showPicture]="false"
        description="{{ 'cannotLoadCompanySettings' | translate }}"
        (retryEmitter)="user ? loadAuthTypes() : loadSettings()">
      </app-something-went-wrong>
    </div>
  }

  @if (!failedSettingsLoading && !settingsIsLoading && isUploaded) {
    <div class="drawer-content-screen__title">
      {{ user ? ('updateUser' | translate) : ('addUserToCompany' | translate) }}
    </div>
    <div class="drawer-content-screen__body">
      <form
        [formGroup]="form"
        autocomplete="off"
        novalidate
        class="flex flex-col gap-2">
        <div class="flex w-full flex-col">
          <mat-form-field>
            <mat-label>{{ 'firstName' | translate }}</mat-label>
            <input
              matInput
              id="firstName"
              formControlName="firstName"
              required />
            @if (form.get('firstName')?.errors) {
              <mat-error>{{
                getFirstNameErrorMessage() | translate
              }}</mat-error>
            }
          </mat-form-field>
          <mat-form-field>
            <mat-label>{{ 'lastName' | translate }}</mat-label>
            <input matInput id="lastName" formControlName="lastName" required />
            @if (form.get('lastName')?.errors) {
              <mat-error>{{ getLastNameErrorMessage() | translate }}</mat-error>
            }
          </mat-form-field>
          <mat-form-field>
            <mat-label>{{ 'email' | translate }}</mat-label>
            <input matInput id="email" formControlName="email" required />
            @if (form.get('email')?.errors) {
              <mat-error>{{ getEmailErrorMessage() | translate }}</mat-error>
            }
          </mat-form-field>
        </div>
        @if (settings?.oidcSupport || user) {
          <div class="flex-col-container-1">
            <mat-checkbox
              color="primary"
              [checked]="gawOidcAuthType"
              (change)="changeGawOidcAuthType($event.checked)">
              {{ 'GAW' | translate }}
            </mat-checkbox>
            <mat-form-field>
              <mat-label>{{ 'nickname' | translate }}</mat-label>
              <input
                matInput
                id="nickName"
                formControlName="nickName"
                required />
              @if (form.get('nickName')?.errors) {
                <mat-error>{{
                  getNicknameErrorMessage() | translate
                }}</mat-error>
              }
            </mat-form-field>
            @if (settings?.oidcSupport || !isUserHasOidc) {
              <mat-form-field>
                <mat-label>{{ 'password' | translate }}</mat-label>
                <input
                  type="password"
                  matInput
                  id="password"
                  formControlName="password"
                  required />
                @if (form.get('password')?.errors) {
                  <mat-error>{{
                    getPasswordErrorMessage() | translate
                  }}</mat-error>
                }
              </mat-form-field>
            }
          </div>
        }
        @if (checkIsValid()) {
          <mat-error>
            {{ 'selectAtLeast1AuthenticationType' | translate }}
          </mat-error>
        }
      </form>
    </div>
    <div class="w-full">
      <div class="flex justify-end">
        <button
          mat-flat-button
          color="primary"
          [disabled]="isLoading || !form.valid || !gawOidcAuthType"
          (click)="onSubmit()">
          <app-loading-button
            text="{{ 'save' | translate }}"
            [loading]="isLoading"></app-loading-button>
        </button>
      </div>
    </div>
  }
</div>
